// PATH: src/components/documents/LessonsRunAlert.tsx
import * as React from "react";
import { Alert, Box, Typography } from "@mui/material";

import { StatusPill } from "../ui";
import type { LessonsRunView } from "./lessonCheck";

/**
 * Bilan d'une extraction par leçon : prêtes / faibles / vides, repris /
 * créés / orphelins (l'orphelin = progression élève perdue), puis les leçons
 * à reprendre avec leur constat.
 */
export const LessonsRunAlert: React.FC<{ view: LessonsRunView; sx?: object }> = ({ view, sx }) => (
  <Alert severity={view.severity} sx={{ "& .MuiAlert-message": { minWidth: 0, flex: 1 }, ...sx }}>
    <Typography variant="body2" fontWeight={600}>
      {view.headline}
    </Typography>
    {view.details.map((d) => (
      <Typography key={d} variant="body2" sx={{ mt: 0.5 }}>
        {d}
      </Typography>
    ))}
    {view.toReview.length > 0 && (
      <Box component="ul" sx={{ m: 0, mt: 0.75, pl: 2.5 }}>
        {view.toReview.map((l) => (
          <li key={l.leconRef}>
            <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 0.75 }}>
              <StatusPill tone={l.tone}>{l.label}</StatusPill>
              <Typography variant="body2" component="span" dir="auto">
                {l.titre || l.leconRef}
              </Typography>
              <Typography variant="caption" component="span" color="text.secondary">
                {l.reason}
              </Typography>
            </Box>
          </li>
        ))}
      </Box>
    )}
  </Alert>
);

export default LessonsRunAlert;
